import { Agenda } from '../translations-types';

const translations: Agenda = {
  title: 'Schedule',
  today: 'Today',
  allEmployees: 'All employees',
  prepCard: 'Open preparation card',
  noCalendar: 'No calendar connected',
  noAppointments: 'No appointments',
  noAppointmentsHint: 'No appointments — sync first in Settings → Salonized.',
  employee: 'Employee',
  unknownEmployee: 'Unknown',
  attendees: 'Attendees',
};

export default translations;
